<script setup>
import Footer from '@/components/common/home-footer.vue'
import { iscData } from '@/mock/index'
</script>
<template>
  <div class="about">
    <img class="aboutVideo" :src="iscData.bgc" alt="" />
    <!-- <video class="aboutVideo" autoplay muted loop>
      <source
        src="https://isc.360kan.com/vod-isc-vod-101240-beijing/TLc6cb7a02328c3f4cc0164dd03a50cb66.mp4"
        type="video/mp4"
      />
      您的浏览器不支持 video 标签。
    </video> -->
    <div class="wrap">
      <p class="aboutTitle">关于我们</p>
      <div class="aboutNav">
        <div class="aboutNavLeft">
          <p class="aboutNavLeftTitle">关于ISC</p>
          <p class="aboutNavLeftText">
            ISC（三六零数字安全科技集团有限公司）成立于2013年，是国内专注为数字安全行业赋能的平台。打造集会展服务、咨询服务、媒体服务、生态创投、生态联盟、产业导入“六维一体”的生态模式，全面赋能国家、政府、行业、企业、个人。过去10年，ISC创办了亚太地区乃至当今世界历史悠久、规格高、辐射广、影响力深远的全球性安全峰会——互联网安全大会，致力于挖掘极具前瞻性的安全观点和发展趋势，凭借高规格和高质量的会、展、赛等形式，深刻影响着产业发展，目前已成为中国网络安全产业风向标。
          </p>
          <!-- <img class="aboutNavLeftImg" src="https://p3.ssl.qhimg.com/t110b9a93016bb1d9ebff6b497c.png" alt="" />
          <p class="aboutNavLeftText">
            “观潮”是中国首先推出多方网络空间智库品牌。由360公司、中国国际战略学会、中国创新与发展战略研究会发起，并在2016年互联网安全大会（ISC2016）期间举办了首次会议。首届论坛邀请了来自美国、俄罗斯、欧盟、中国的多名发言人以及来自政府、企业、军队的多位学者，围绕全球互联网治理体系和网络空间规范等问题展开对话。
          </p> -->
          <!-- <p class="aboutNavLeftText">使命：促进网络空间创新、安全、交流、合作。</p> -->
          <div class="aboutNavLeftQr">
            <p>
              <!-- <img src="https://p4.ssl.qhimg.com/t01b6a479449846bbfe.png" alt="" />
              <span>ISC APP下载</span> -->
            </p>
            <p>
              <!-- <img src="https://p5.ssl.qhimg.com/t01a2702c5e5b1d4b5e.png" alt="" />
              <span>微信公众号</span> -->
            </p>
          </div>
        </div>
        <div class="aboutNavRight">
          <p></p>
          <p class="aboutNavLeftTitle">联系我们</p>
          <div class="aboutNavRightDesc">
            <!-- ISC商务
            <p class="right"></p>
            马欣：15718876610
            <p class="right"></p> -->
            微信：ISC平台
            <p class="right"></p>
            微博：ISC官方微博
            <p class="right"></p>
            邮箱：ISC@360.cn
            <p class="right"></p>
            投诉通道：ISC@360.cn
            <p class="right"></p>
            互联网安全大会
            <p class="right"></p>
            <a target="_blank" href="https://isc.360.com/2020/disclaimer.html">
              <u>免责声明及投诉指引</u>
            </a>
            <p class="right"></p>
            <a target="_blank" href="https://isc.360.com/2020/user-protocol.html">
              <u>《ISC用户服务协议》</u>
            </a>
            <p class="right"></p>
            <a target="_blank" href="https://isc.360.com/2020/login/xy.html">
              <u>《ISC隐私协议》</u>
            </a>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<style lang="scss" scoped>
p {
  margin: 0;
}
.about {
  position: relative;
  width: 100%;
  height: calc(100vh - 64px);
  background: url('https://p1.ssl.qhimg.com/t016f31c171a38d9b07.jpg') 100% 100%;
  .wrap {
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &Video {
    position: absolute;
    width: 100%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  &Title {
    height: 46px;
    background: url('https://s0.ssl.qhres2.com/static/bd72b716524545b6.svg') no-repeat center;
    margin: 0 0 64px;
    line-height: 46px;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
  }
  &Nav {
    position: relative;
    width: 1163px;
    height: 430px;
    background: #ffffff80;
    margin: 0 auto;
    padding: 40px 0px 0 48px;
    text-align: left;
  }
  &NavLeft {
    position: absolute;
    top: 40px;
    left: 48px;
    display: inline-block;
    // width: 841px;
    // height: 100%;
    // height: 328px;
    text-align: left;
    border-right: 1px solid #dedede;
    &Title {
      font-weight: bold;
      font-size: 24px;
      color: #222222;
      line-height: 44px;
      margin-bottom: 20px;
      // padding-top: 20px;
    }
    &Text {
      display: inline-block;
      width: calc(100% - 380px);
      // height: 245px;
      font-size: 16px;
      color: #4a506b;
      line-height: 24px;
      margin-right: 84px;
      text-align: justify;
    }
    &Img{
      width: 82px;
      margin-top: 50px;
      margin-bottom: 28px;
    }
    &Qr {
      position: relative;
      transform: translateY(-25%);
      display: inline-block;
      text-align: center;
      p {
        display: inline-block;
        margin-right: 48px;
        margin-bottom: 8px;
        text-align: center;
        width: 120px;
        height: 120px;
      }
      img {
        width: 100%;
      }
      span {
        font-size: 14px;
        color: #222222;
      }
    }
  }
  &NavRight {
    position: absolute;
    top: 40px;
    right: 0px;
    display: inline-block;
    width: 322px;
    text-align: left;
    padding-right: 103px;
    padding-left: 48px;
    // margin-left: 48px;
    .right {
      height: 10px;
    }
    &Desc {
      font-size: 14px;
      color: #4a506b;
      line-height: 19px;
      width: 171px;
      height: 228px;
    }
  }
}
</style>
